import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from "@ngx-translate/core";
import { InformationComponent } from '../../../../shared/modals/information/information.component';
import { EFormsOrgService } from '../../services/e-forms-org.service';
import { EformAccordionService } from '../../services/eform-accordion.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent implements AfterViewInit, OnInit, OnDestroy, OnChanges {
  private static instanceCounter = 0;
  private uniqueId: string;
  private subscription: Subscription;

  @Input() elementLabel: string;
  @Input() isDeletable: boolean;
  @Input() elementId: string;
  @Input() isRepeatable: boolean;
  @Input() infoBulle: string;
  @Input() prefixId: string;
  @Input() isExpanded: boolean = true; // 🔧 FIX: Permet au parent de contrôler l'état d'expansion
  @Input() groupType: string; // 🔧 FIX: Type de groupe pour regrouper les accordéons (ex: "GR-Lot-AwardCriteria-Criterion")
  @Output() addSomething = new EventEmitter();
  @Output() deleteSomething = new EventEmitter();

  private tempButtonEl: HTMLElement;
  private tempPanelId: string;
  private tempPanelEl: HTMLElement;


  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private translateService: TranslateService,
    private modalService: NgbModal,
    private eFormsOrgService: EFormsOrgService,
    private eformAccordionService: EformAccordionService
  ) {
    // Générer un ID unique pour cette instance
    this.uniqueId = `accordion-${AccordionComponent.instanceCounter++}`;
  }

  ngOnInit(): void {
    // S'abonner aux événements de repliage pour ce type de groupe
    if (this.groupType) {
      this.subscription = this.eformAccordionService.collapseOthers$.subscribe(({ groupType, exceptId }) => {
        if (this.groupType === groupType && this.elementId !== exceptId) {
          this.collapse();
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Réagir aux changements de isExpanded depuis le parent
    if (changes['isExpanded'] && !changes['isExpanded'].firstChange && this.tempButtonEl) {
      this.prepareData();
      if (changes['isExpanded'].currentValue) {
        this.expand();
      } else {
        this.collapse();
      }
    }
  }

  // 🔧 FIX 2026-02-10: Masquer les accordéons GR-Unpublish (toujours vides)
  isGrUnpublish(): boolean {
    return this.elementId?.startsWith('GR-Unpublish');
  }

  getUniqueAccordionId(): string {
    return `${this.prefixId}-${this.elementId}-${this.uniqueId}`;
  }

  ngAfterViewInit() {
    this.tempButtonEl = this.elementRef.nativeElement.querySelector('#' + this.getUniqueAccordionId());
    if (this.tempButtonEl) {
      //Prépare les listeners pour l'ouverture/fermeture des accordeons
      this.tempButtonEl.addEventListener('click', () => {
        this.prepareData();
        const isOpen = this.tempButtonEl.getAttribute('aria-expanded') === 'true';
        this.updateAccordionHtml(isOpen);
      })
    }
  }

  getAccordionTitle(): string {
    let title = this.translateService.instant(this.elementLabel);
    if (this.elementId) {
      title += " (" + this.translateService.instant(this.elementId) + ")";
    }
    if (title.includes("(GR-Organisations)")) {
      title += " - ORG-0001 - Acheteur";
    }
    if (title.includes("(GR-Organisations_")) {
      let orgNumber: string = title.slice(56, -1);
      orgNumber = "0000".slice(orgNumber.length) + (parseInt(orgNumber) + 1);
      title = title.slice(0, 55) + ")";
      title += " - ORG-" + orgNumber;

      if (title.includes("ORG-0002") && this.eFormsOrgService.getNeedSecondOrganization()) {
        title += " - Organisation de recours";
      }
    }

    return title;
  }

  getEvent(event: Event) {
    event.stopPropagation();
    const modalRef = this.modalService.open(InformationComponent);
    modalRef.componentInstance.content = this.translateService.instant(this.infoBulle);
  }

  updateAccordionHtml(isOpen: boolean) {
    //Inverse les attributs dans le HTML, l'accordeon s'ouvre ou se ferme
    this.renderer.setAttribute(this.tempButtonEl, 'aria-expanded', String(!isOpen));
    if (isOpen) {
      //La section située sous l'accordeon se cache
      this.renderer.setAttribute(this.tempPanelEl, 'hidden', ' ');
    } else {
      // ou s'affiche
      this.renderer.removeAttribute(this.tempPanelEl, 'hidden');
    }
  }

  /**
   * 🔧 FIX 2026-02-26: Méthode publique pour replier l'accordéon
   */
  public collapse(): void {
    if (this.tempButtonEl) {
      this.prepareData();
      const isOpen = this.tempButtonEl.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        this.updateAccordionHtml(true); // true = fermer
      }
    }
  }

  /**
   * 🔧 FIX 2026-02-26: Méthode publique pour déplier l'accordéon
   */
  public expand(): void {
    if (this.tempButtonEl) {
      this.prepareData();
      const isOpen = this.tempButtonEl.getAttribute('aria-expanded') === 'true';
      if (!isOpen) {
        this.updateAccordionHtml(false); // false = ouvrir
      }
    }
  }

  prepareData() {
    this.tempPanelId = this.tempButtonEl.getAttribute('aria-controls');
    this.tempPanelEl = document.getElementById(this.tempPanelId);
  }

  removeSomething() {
    this.deleteSomething.emit();
  }

  createSomething() {
    this.addSomething.emit();
  }
}
